import moment from "moment";
export var locationUtil = {
  getWaitListObject: function getWaitListObject(location) {
    var qsrTimeFormat = 'h:mm A';
    var now = moment();
    var clientDayName = moment().format('dddd');
    var clientNextDayName = moment().add(1, 'day').format('dddd'); // confirm webaheadstatus means what I think it it means

    var storeIsClosedBasedOnServerTime = (location === null || location === void 0 ? void 0 : location.webaheadstatus) == 'NotAccepting';
    var result = {
      storeIsClosedBasedOnServerTime: false,
      isWaitlistAvailable: !storeIsClosedBasedOnServerTime,
      todayOpeningTime: '7:00 AM',
      todayClosingTime: '10:00 PM',
      tomorrowOpeningTime: '7:00 AM',
      tomorrowClosingTime: '10:00 PM',
      qsrTimeFormat: qsrTimeFormat
    };

    if (location) {
      if (location.hasOwnProperty('sundayClose')) {
        clientDayName = clientDayName.charAt(0).toLowerCase() + clientDayName.slice(1);
        clientNextDayName = clientNextDayName.charAt(0).toLowerCase() + clientNextDayName.slice(1);
        result.todayClosingTime = moment(location[clientDayName + 'Close'], qsrTimeFormat);
        result.todayOpeningTime = moment(location[clientDayName + 'Open'], qsrTimeFormat);
        result.tomorrowClosingTime = moment(location[clientNextDayName + 'Close'], qsrTimeFormat);
        result.tomorrowOpeningTime = moment(location[clientNextDayName + 'Open'], qsrTimeFormat);
      } else {
        result.todayClosingTime = moment(location[clientDayName + 'Close'], qsrTimeFormat);
        result.todayOpeningTime = moment(location[clientDayName + 'Open'], qsrTimeFormat);
        result.tomorrowClosingTime = moment(location[clientNextDayName + 'Close'], qsrTimeFormat);
        result.tomorrowOpeningTime = moment(location[clientNextDayName + 'Open'], qsrTimeFormat);
      }
    }

    if (!result.todayOpeningTime) result.todayOpeningTime = '7:00 AM';
    if (!result.todayClosingTime) result.todayClosingTime = '10:00 PM';
    if (!result.tomorrowOpeningTime) result.tomorrowOpeningTime = '7:00 AM';
    if (!result.tomorrowClosingTime) result.tomorrowClosingTime = '10:00 PM';
    return result;
  },
  isTimeBetween: function isTimeBetween(startTimeAsMoment, endTimeAsMoment, serverTimeAsMoment) {
    if (endTimeAsMoment < startTimeAsMoment) {
      return serverTimeAsMoment >= startTimeAsMoment && serverTimeAsMoment <= moment('23:59:59', "h:mm:ss") || serverTimeAsMoment >= moment('0:00:00', "h:mm:ss") && serverTimeAsMoment < endTimeAsMoment;
    }

    return serverTimeAsMoment >= startTimeAsMoment && serverTimeAsMoment < endTimeAsMoment;
  },
  getWaitListText: function getWaitListText(location) {
    if (!location) return '';
    var now = moment();
    var waitTimeText = (location === null || location === void 0 ? void 0 : location.waitlist_flag) && (location === null || location === void 0 ? void 0 : location.avgwaittime) ? " - ".concat(location === null || location === void 0 ? void 0 : location.avgwaittime, " wait time") : "";

    try {
      var _locationUtil$getWait = locationUtil.getWaitListObject(location),
          todayClosingTime = _locationUtil$getWait.todayClosingTime,
          todayOpeningTime = _locationUtil$getWait.todayOpeningTime,
          tomorrowOpeningTime = _locationUtil$getWait.tomorrowOpeningTime,
          qsrTimeFormat = _locationUtil$getWait.qsrTimeFormat;

      if (!locationUtil.isTimeBetween(todayOpeningTime, todayClosingTime, now)) {
        if (now.isBefore(todayOpeningTime)) {
          waitTimeText = ' - Opens today at ' + todayOpeningTime.format(qsrTimeFormat);
        } else {
          waitTimeText = ' - Opens ' + tomorrowOpeningTime.format(qsrTimeFormat) + ' tomorrow';
        }
      }
    } catch (error) {
      console.error('time issue', error);
    }

    return waitTimeText;
  },
  getWaitTimeButtonText: function getWaitTimeButtonText(location) {
    //data.avgWaitTime.replace('About ', '').split(' ')[0]} min wait`
    if (!location) {
      return '';
    }

    var waitTimeText = (location === null || location === void 0 ? void 0 : location.avgwaittime) ? "".concat(location === null || location === void 0 ? void 0 : location.avgwaittime.replace('About ', '').split(' ')[0], " min wait") : "";
    return waitTimeText;
  },
  isWaitListAvailable: function isWaitListAvailable(location) {
    var isAvailable = (location === null || location === void 0 ? void 0 : location.waitlist_flag) && (location === null || location === void 0 ? void 0 : location.webaheadstatus) === 'Available' || (location === null || location === void 0 ? void 0 : location.waitlist); // why why why we can't be consistent

    var _locationUtil$getWait2 = locationUtil.getWaitListObject(location),
        todayClosingTime = _locationUtil$getWait2.todayClosingTime,
        todayOpeningTime = _locationUtil$getWait2.todayOpeningTime;

    if (!locationUtil.isTimeBetween(todayOpeningTime, todayClosingTime, moment())) {
      isAvailable = false;
    }

    return isAvailable;
  }
};